import { getAxios } from './apiUtils';

// INVOICES
export const addInvoice = async user => {
  try {
    return await getAxios().post('/api/invoice', user);
  } catch (error) {
    throw new Error(error.message);
  }
};

export const updateInvoice = async user => {
  try {
    return await getAxios().put('/api/invoice', user);
  } catch (error) {
    throw new Error(error.message);
  }
};
export const getInvoices = async () => {
  try {
    const invoices = await getAxios().get('/api/invoice');
    return invoices.data;
  } catch (error) {
    throw new Error(error.message);
  }
};
export const searchInvoices = async query => {
  try {
    const invoices = await getAxios().post('/api/invoice/search', query);
    return invoices.data;
  } catch (error) {
    throw new Error(error.message);
  }
};
export const getInvoiceById = async id => {
  try {
    const invoice = await getAxios().get(`/api/invoice/${id}`);
    return invoice.data;
  } catch (error) {
    throw new Error(error.message);
  }
};
